import React from 'react';
import { Outlet } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import SideBar from './SideBar';
import HeaderUser from './HeaderUser';
import ForceProfileUpdate from '../ForceProfileUpdate';
import { LoaderComponent } from '../ui';

/**
 * Renders the full Pagali layout (sidebar + header) if the user is authenticated,
 * or just the page content without layout for anonymous users.
 * Used for pages that are public but should show the app shell when logged in.
 */
const ConditionalMain: React.FC = () => {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return <LoaderComponent size="lg" text="A carregar..." fullScreen />;
  }

  if (!isAuthenticated) {
    return <Outlet />;
  }

  return (
    <div className="flex h-screen bg-pagali-gray-50 overflow-hidden">
      <ForceProfileUpdate />
      <SideBar />
      <div className="flex-1 flex flex-col overflow-hidden">
        <HeaderUser />
        <main className="flex-1 overflow-y-auto">
          <div className="page-content">
            <Outlet />
          </div>
        </main>
        <footer className="py-4 px-6 bg-white border-t border-pagali-gray-200">
          <p className="text-center text-xs text-pagali-gray-400">
            © {new Date().getFullYear()} Pagali - Todos os direitos reservados
          </p>
        </footer>
      </div>
    </div>
  );
};

export default ConditionalMain;
